import { createChannelManagementInstance } from '../api-instance';
import type { TRequestOptions } from '../types';

export interface OzonConnectRequest {
  client_id: string;
  api_key: string;
  name?: string;
}

export interface OzonConnectResponse {
  status: 'ready';
}

export const connectOzon = (
  channelId: string,
  data: OzonConnectRequest,
  options?: TRequestOptions
): Promise<OzonConnectResponse> =>
  createChannelManagementInstance<OzonConnectResponse>(
    {
      url: `/api/v1/channels/${encodeURIComponent(channelId)}/ozon/connect`,
      method: 'POST',
      data,
    },
    options
  );

export const disconnectOzon = (
  channelId: string,
  options?: TRequestOptions
): Promise<void> =>
  createChannelManagementInstance<void>(
    {
      url: `/api/v1/channels/${encodeURIComponent(channelId)}/ozon/disconnect`,
      method: 'POST',
      data: {},
    },
    options
  );
